import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ['editing']

  toggle() {
    this.element.classList.toggle(this.editingClass)
  }
}
